import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-inner">
          <div className="logo">
            <img src="https://customer-assets.emergentagent.com/job_premium-consult-7/artifacts/ns5c9dvr_owllogofinal.png" alt="OWL EYES" className="logo-image" />
          </div>
          
          <nav className="nav">
            <a href="#about" className="nav-item">About</a>
            <span className="nav-separator">·</span>
            <a href="#services" className="nav-item">Services</a>
            <span className="nav-separator">·</span>
            <a href="/demo/" className="nav-item">Solutions</a>
            <span className="nav-separator">·</span>
            <a href="#blogs" className="nav-item">Resources</a>
            <span className="nav-separator">·</span>
            <a href="#contact" className="nav-item">Contact</a>
          </nav>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>
      
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <a href="#about" className="mobile-nav-item" onClick={() => setMobileMenuOpen(false)}>About</a>
          <a href="#services" className="mobile-nav-item" onClick={() => setMobileMenuOpen(false)}>Services</a>
          <a href="/demo/" className="mobile-nav-item" onClick={() => setMobileMenuOpen(false)}>Solutions</a>
          <a href="#blogs" className="mobile-nav-item" onClick={() => setMobileMenuOpen(false)}>Resources</a>
          <a href="#contact" className="mobile-nav-item" onClick={() => setMobileMenuOpen(false)}>Contact</a>
        </div>
      )}
    </header>
  );
};

export default Header;